<template>
  <div class="task-detail-page">
    <!-- 任务信息卡片 -->
    <div class="detail-card">
      <div class="detail-title">{{ detail.projectName || '任务详情' }}</div>
      <div class="detail-row"><span class="row-label">发布企业：</span><span class="row-value">{{ detail.merName }}</span></div>
      <div class="detail-row"><span class="row-label">服务地点：</span><span class="row-value">{{ locationText }}</span></div>
      <div class="detail-row"><span class="row-label">服务时间：</span><span class="row-value">{{ serviceTimeText }}</span></div>
      <div class="detail-row"><span class="row-label">招募人数：</span><span class="row-value">{{ detail.recruitCount }}人</span></div>
      <div class="detail-row"><span class="row-label">已报名：</span><span class="row-value">{{ detail.signCount }}人</span></div>

      <div v-if="detail.salaryRange" class="detail-section">
        <div class="section-title">服务报酬</div>
        <div class="section-text price-text">{{ detail.salaryRange }}元</div>
      </div>
      <div v-if="detail.describe" class="detail-section">
        <div class="section-title">服务内容</div>
        <div class="section-text">{{ detail.describe }}</div>
      </div>
      <div v-if="detail.acceptance" class="detail-section">
        <div class="section-title">验收标准</div>
        <div class="section-text">{{ detail.acceptance }}</div>
      </div>

      <!-- 报名说明 -->
      <div class="notice-card">
        <div class="notice-title">⚠️ 报名说明</div>
        <div class="notice-text">{{ notice }}</div>
      </div>

    </div>
    <!-- 立即报名（右对齐） -->
    <div class="signup-action">
      <van-button class="signup-btn" round @click="goSignUp">立即报名</van-button>
    </div>

  </div>
</template>
<script>
import { NavBar } from 'vant'
import requestHomeAPI from '@/axios/HomeApi'

export default {
  name: 'TaskDetail',
  components: {
    [NavBar.name]: NavBar
  },
  data () {
    return {
      // 任务详情数据（对应 projectDetails 接口返回字段）
      detail: {
        projectId: '',
        projectName: '',
        merId: '',
        merNo: '',
        merName: '',
        provinceName: '',
        cityName: '',
        districtName: '',
        recruitCount: '',
        signCount: '',
        salaryRange: '',
        createTime: '',
        endTime: '',
        describe: '',
        acceptance: '' // 接口暂无此字段，预留
      },
      // 报名说明（接口暂无此字段，静态文案）
      notice: '报名后，您将申请参与该企业发布的服务任务。审核通过后进入后续签约流程。'
    }
  },
  computed: {
    // 省市区拼接，直辖市（省市同名）去重
    locationText () {
      const parts = [this.detail.provinceName, this.detail.cityName, this.detail.districtName]
      return parts
        .filter((part, i) => part && (i === 0 || part !== parts[i - 1]))
        .join('')
    },
    // 服务时间区间
    serviceTimeText () {
      const { createTime, endTime } = this.detail
      if (createTime && endTime) {
        return `${createTime} ～ ${endTime}`
      }
      return createTime || endTime || ''
    }
  },
  created () {
    const projectId = this.$route.query.projectId
    console.log('获取到的项目id', projectId)
    if (!projectId) {
      this.$notify({ type: 'danger', message: '缺少项目ID' })
      return
    }
    this.getDetail(projectId)
  },
  methods: {
    // 获取任务详情
    getDetail (projectId) {
      requestHomeAPI.projectDetails({ projectId }).then(res => {
        if (res.data.code === '0000') {
          const data = res.data.data || {}
          this.detail = {
            ...this.detail,
            projectId: data.projectId,
            projectName: data.projectName,
            merId: data.merId,
            merNo: data.merNo,
            merName: data.merName,
            provinceName: data.provinceName,
            cityName: data.cityName,
            districtName: data.districtName,
            recruitCount: data.recruitCount,
            signCount: data.signCount,
            salaryRange: data.salaryRange,
            createTime: data.createTime,
            endTime: data.endTime,
            describe: data.describe,
            acceptance: data.acceptance || ''
          }
        } else {
          this.$notify({ type: 'danger', message: res.data.message })
        }
      }).catch(() => {
        this.$notify({ type: 'danger', message: '加载失败，请重试' })
      })
    },
    // 跳转到立即报名页
    goSignUp () {
      this.$router.push({
        path: '/signUp',
        query: {
          projectId: this.detail.projectId,
          merId: this.detail.merId,
          merNo: this.detail.merNo,
          projectName: this.detail.projectName,
          merName: this.detail.merName,
          serviceTime: this.serviceTimeText
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
/*
 * 注意：项目 postcss 按 750 设计稿宽度将 px 自动转成 vw（src 代码），
 * 即源码数值是设计稿坐标，实际渲染大小 = 数值 ÷ 2。
 */
.task-detail-page {
  min-height: 100%;
  padding-bottom: 160px; /* 给底部固定的报名按钮留出空间 */
  background: #f5f5f5;
  overflow: hidden;
}

.detail-card {
  margin: 20px;
  padding: 32px;
  background: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;

  .detail-title {
    font-size: 42px;
    font-weight: 600;
    color: #323233;
    margin-bottom: 24px;
  }

  .detail-row {
    font-size: 30px;
    line-height: 48px;
    margin-bottom: 8px;

    /* 左侧标签浅色，右侧内容深色 */
    .row-label {
      color: #999;
    }

    .row-value {
      color: #323233;
    }
  }

  .detail-section {
    width: 100%;
    margin-top: 32px;
    padding-top: 32px;
    border-top: 1px solid #f5f5f5;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .section-title {
      font-size: 36px;
      font-weight: 600;
      color: #323233;
      margin-bottom: 16px;
    }

    .section-text {
      font-size: 30px;
      color: #666;
      line-height: 48px;
      white-space: pre-line;
      text-align: left;
    }
    .price-text {
      font-size: 36px;
      color: #e92504;
      font-weight: 600;
    }
  }
}

.notice-card {
  margin-top: 10px;
  padding: 32px;
  background: #fffbe8;
  border-radius: 16px;

  .notice-title {
    font-size: 32px;
    font-weight: 600;
    color: #ed6a0c;
    margin-bottom: 16px;
    text-align: left;
  }

  .notice-text {
    font-size: 26px;
    color: #666;
    line-height: 38px;
    white-space: pre-line;
    text-align: left;
  }
}

/* 立即报名按钮：固定在底部，按钮通栏 */
.signup-action {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);

  .signup-btn {
    width: 100%;
    font-size: 30px;
    height: 76px;
    border-radius: 999px;
    background: #e92504; /* rgb(233, 37, 4) */
    border-color: #e92504;
    color: #fff;
  }
}
</style>
